<script lang="ts">
  import type { PostStoryblok } from "$types/components";
  import { ButtonColor } from "$types/atoms";
  import ButtonLink from "$lib/atoms/ButtonLink.svelte";
  export let blok: PostStoryblok;

  const cta = blok.cta && blok.cta.length > 0 ? blok.cta[0] : null;
</script>

<!-- CTA -->
{#if cta && cta?.backgroundColor?.length > 0 && cta?.heading?.length > 0}
  <section
    class="mx-auto post-content-max-width padding-top-50 padding-bottom-100 px-[20px]"
    style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);"
  >
    <div
      class="xl:mx-[-15%] padding-top-120 padding-bottom-120 rounded-lg text-center px-10 {cta.backgroundColor ===
      'yellow'
        ? 'bg-yellow'
        : 'bg-blue'}"
    >
      <p
        class="type:h2 md:max-w-[80%] mx-auto {cta.backgroundColor === 'yellow'
          ? 'text-charcoal'
          : 'text-white'}"
      >
        {cta.heading}
      </p>
      {#if cta?.buttonLink?.length > 0}
        <div class="flex justify-center mt-[60px]">
          <ButtonLink
            blok={cta.buttonLink[0]}
            color={cta.buttonLink[0].color === "white"
              ? ButtonColor.WHITE
              : ButtonColor.BLACK}
          />
        </div>
      {/if}
    </div>
  </section>
{/if}
